import React from 'react';
import styles from './not-moderated-chats.module.scss';
import { Button, Typography } from '@/ui-kit';
import { MessageIcon, RemoderationIcon } from '@/assets/icons';
import { routesApp } from '@/constans/routes';

interface Props {}

export const NotModeratedChats: React.FC<Props> = () => {
    return (
        <div className={styles.wrapper}>
            <RemoderationIcon className={styles.remoderationCardContentIcon} />
            <Typography
                fontWeight="semibold"
                center
                fontFamily="SFProText"
                className={styles.title}>
                Отредактируй свои данные,<br />чтобы пройти модерацию
            </Typography>
            <Typography
                center
                fontFamily="SFProText"
                className={styles.text}>
                После прохождения проверки твой профиль будет показываться в ленте и тебя смогут лайкать
            </Typography>
            <Button
                className={styles.button}
                typeColor="orange"
                isLink
                to={routesApp.profileEdit}>
                Перейти в профиль
            </Button>
        </div>
    );
};
